import React, { useState, useEffect } from "react"
import { Card, CardHeader, CardBody, CardFooter, Alert, Spinner } from "reactstrap"
import { NumberDisplay, Loader } from "components"
import colors from "assets/colors"
import { fetchDashboard } from "api/dashboardApi"

const DashboardSection = ({ trigger, type, title, fields, params }) => {
  const [data, setData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const { success, message, data } = await fetchDashboard(params)

        if (!success) throw new Error(message)
        setData(data)
        setError(null)
      } catch (error) {
        console.error(error)
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [trigger])

  return (
    <Card>
      <CardHeader style={{ backgroundColor: colors.primary, color: colors.white }}>
        {title}
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <Spinner />
        ) : error ? (
          <Alert color="danger">에러 발생</Alert>
        ) : (
          fields
          .filter(field => !field.isFooter)
          .map(({ label, key, suffix }) => (
            <div key={key} className="card-body-index">
              <span>{label}</span>
              <NumberDisplay value={data?.[key] || 0} suffix={suffix} />
            </div>
          ))
        )}
      </CardBody>
      {fields.some(field => field.isFooter) && (
        <CardFooter>
          {fields
            .filter(field => field.isFooter)
            .map(({ label, key, suffix }) => (
              <div key={key} className="card-body-index">
                <span>{label}</span>
                <NumberDisplay value={data?.[key] || 0} suffix={suffix} />
              </div>
            ))}
        </CardFooter>
      )}
    </Card>
  )
}

export default DashboardSection
